export enum SoftwareInterfaceType {
  library = 'library',
  commandLine = 'command-line application',
  desktopApplication = 'desktop application',
  mobileApplication = 'mobile application',
  webService = 'web service',
  webApplication = 'web application',
  bioSimulatorsDockerImage = 'BioSimulators Docker image',
}
